import client from "./client";

/* 배너 관리 */

export const createBanner = (params) => client.post(`/banner/`, params);

export const getBanners = (params) => client.get(`/banner/`, { params });

export const getBanner = ({ id }) => client.get(`/banner/${id}/`);

export const editBanner = (params) =>
  client.put(`/banner/${params.id}/`, params);

export const deleteBanner = ({ id }) =>
  client.delete(`/banner/${id}/`);


export const deleteBanners = ({ selectedItems }) =>
  client.delete(`/banner-multi-delete/`, { data: { ids: selectedItems } });

export const saveBannerImage = (image) => {
  let formData = new FormData();
  formData.append("image", image);
  return client.post(`/banner-image/`, formData);
};

/* 약관 관리 */

export const createTerm = (params) => client.post(`/terms/`, params);

export const getTerms = (params) => client.get(`/terms/`, { params });

export const getTerm = ({ id }) => client.get(`/terms/${id}/`);

export const editTerm = (params) => client.put(`/terms/${params.id}/`, params);

export const deleteTerms = ({ selectedItems }) =>
  client.delete(`/terms-multi-delete/`, { data: { ids: selectedItems } });

/* config */

export const createConfig = (params) => client.post(`/config/`, params);

export const getConfigs = (params) => client.get(`/config/`, { params });

export const getConfig = ({ id }) => client.get(`/config/${id}/`);

export const editConfig = (params) =>
  client.put(`/config/${params.id}/`, params);

export const deleteConfigs = ({ selectedItems }) =>
  client.delete(`/config-multi-delete/`, {
    data: { ids: selectedItems },
  });


export const getSmsConfigs = (params) => client.get(`/sms-format/`, { params });
export const editSmsConfig = (params) => client.put(`/sms-format/${params?.id}/`, params);



export const savePushAlarmImage = (image) => {
  let formData = new FormData();
  formData.append("image", image);
  return client.post(`/alarm-history-image/`, formData);
};
